const PermissionSubject = [
  'Moments',
  'IBHealth',
  'Clinical',
  'NPIListDownload',
  'SmartActionWebHook',
  'ChannelsOperational',
  'HCP365',
  'SmartActionsAllowed',
  'NPIDetails',
  'NPIProfessions',
  'PatientDetails',
  'HCP365AccountLevel',
  'ShowPII',
  'Reports',
] as const;
export type PermissionSubject = (typeof PermissionSubject)[number];

export type StudioPermissionState = Record<PermissionSubject, boolean>;
export const DefaultPermissionsState: StudioPermissionState = {
  Moments: false,
  Clinical: false,
  IBHealth: false,
  NPIListDownload: false,
  SmartActionWebHook: false,
  ChannelsOperational: false,
  HCP365: false,
  SmartActionsAllowed: false,
  NPIDetails: false,
  NPIProfessions: false,
  PatientDetails: false,
  HCP365AccountLevel: false,
  ShowPII: false,
  Reports: false,
};
